import { BatteryStatus } from '@ui/aos-lib';
import { BatterySeverities, Status } from '../../health-api.types';
import { BatteryStatistic } from '../../health-monitor.types';
import { Calc } from 'src/app/shared/utils/calc';
import { getCapitalizedString } from 'src/app/shared/utils';

const calculatePercentages = (batteryStatuses: BatteryStatistic, totalCount: number): void => {
  for (const key in batteryStatuses) {
    batteryStatuses[key as BatteryStatus].percent = Math.round(
      Calc.percent(batteryStatuses[key as BatteryStatus].count, totalCount) as number
    );
  }
};

export const calculateTotalCountBatteryCapacity = (devices: BatterySeverities[]): BatteryStatistic => {
  const batteryStatuses = {
    Good: { percent: 0, count: 0 },
    Notice: { percent: 0, count: 0 },
    Warning: { percent: 0, count: 0 },
    Severe: { percent: 0, count: 0 },
    Critical: { percent: 0, count: 0 },
    Empty: { percent: 0, count: 0 }
  };
  for (const key in batteryStatuses) {
    batteryStatuses[key as BatteryStatus].count = 0;
  }
  let batteryCapacityTotalCount = 0;

  devices.forEach(device => {
    batteryCapacityTotalCount = device.severities
      .filter(severity => severity.key !== Status.Unknown)
      .reduce((acc, cur) => {
        return acc + cur.value;
      }, batteryCapacityTotalCount);

    device.severities.forEach(status => {
      if (status.key.toUpperCase() === Status.Unknown) {
        return;
      }
      const key = getCapitalizedString(status.key);
      batteryStatuses[key as BatteryStatus].count += status.value;
    });
  });

  for (const key in batteryStatuses) {
    batteryStatuses[key as BatteryStatus].percent = Math.round(
      Calc.percent(batteryStatuses[key as BatteryStatus].count, batteryCapacityTotalCount) as number
    );
  }

  calculatePercentages(batteryStatuses, batteryCapacityTotalCount);
  return batteryStatuses;
};
